import { useParams } from 'react-router-dom';
import { useEvents, useReel } from '../api/hooks';
import { formatWhen } from '../lib/format';
import { ErrorView, Loading, Screen } from '../ui/Screen';
import { stagePath } from '../ui/Stepper';

export function HistoryScreen() {
  const { reelId = '' } = useParams();
  const reel = useReel(reelId);
  const events = useEvents(reelId);
  const back = reel.data ? stagePath(reelId, reel.data.reel.stage) : '/';

  if (events.isError) return <ErrorView title="History" back={back} error={events.error} />;
  if (events.isPending) return <Loading title="History" />;
  const list = [...events.data].sort((a, b) => b.at.localeCompare(a.at));

  return (
    <Screen title="History" back={back}>
      {list.length === 0 ? (
        <p className="muted">Nothing happened yet.</p>
      ) : (
        <ol className="trace" aria-label="History, newest first">
          {list.map((e) => (
            <li key={e.id}>
              <time dateTime={e.at}>{formatWhen(e.at)}</time>
              <span>
                <em>{e.actor.name}</em>
                {e.message}
              </span>
            </li>
          ))}
        </ol>
      )}
    </Screen>
  );
}
